<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 26 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M4.434 22.033c-2.246-2.254-3.635-5.364-3.635-8.798s1.389-6.544 3.636-8.799l-0 0c2.237-2.25 5.335-3.643 8.758-3.643 0.014 0 0.029 0 0.043 0h-0.002c0.007-0 0.016-0 0.025-0 3.428 0 6.531 1.392 8.774 3.643l0 0c2.246 2.254 3.635 5.364 3.635 8.798s-1.389 6.544-3.636 8.799l0-0-8.761 8.836z"
      />
      <path
        fill="#464646"
        d="M13.233 1.588c0.007 0 0.015-0 0.023-0 3.209 0 6.115 1.303 8.215 3.409l0 0c2.106 2.095 3.409 4.995 3.409 8.199 0 0.014-0 0.027-0 0.041v-0.002c0 0.007 0 0.015 0 0.023 0 3.209-1.303 6.115-3.409 8.215l-0 0-8.2 8.267-8.272-8.272c-2.106-2.095-3.409-4.995-3.409-8.199 0-0.014 0-0.027 0-0.041v0.002c0-0.007-0-0.015-0-0.023 0-3.209 1.303-6.115 3.409-8.215l0-0c2.102-2.101 5.005-3.4 8.212-3.4 0.009 0 0.018 0 0.028 0h-0.001zM13.238 0.003c-0.007 0-0.016-0-0.025-0-3.647 0-6.949 1.482-9.335 3.876l-0 0c-2.395 2.396-3.876 5.705-3.876 9.361s1.481 6.965 3.876 9.361l9.396 9.405 9.321-9.396c2.395-2.396 3.876-5.705 3.876-9.361s-1.481-6.965-3.876-9.361l0 0c-2.386-2.4-5.69-3.886-9.341-3.886-0.007 0-0.014 0-0.021 0h0.001z"
      />
      <path
        fill="#fff"
        d="M21.068 15.693l-1.099-0.891v-3.136l-1.757-1.415-1.748 1.415v7.936h4.604zM18.212 12.007c0.282 0 0.51 0.229 0.51 0.51s-0.229 0.51-0.51 0.51c-0.282 0-0.51-0.229-0.51-0.51v0c0-0.001 0-0.002 0-0.003 0-0.28 0.227-0.506 0.506-0.506 0.002 0 0.003 0 0.005 0h-0z"
      />
      <path
        fill="#fff"
        d="M14.595 10.052v-0.753l-1.722-0.666v-2.907h-0.509v2.916l-1.696 0.653v0.753h-1.332l-0.020 9.541h0.718v-1.142c0.002-0.34 0.279-0.614 0.619-0.614 0.342 0 0.619 0.277 0.619 0.619 0 0.002 0 0.003-0 0.005v-0 1.142h0.718v-1.137c-0-0.006-0-0.014-0-0.021 0-0.342 0.277-0.619 0.619-0.619s0.619 0.277 0.619 0.619c0 0.011-0 0.021-0.001 0.031l0-0.001v1.142h0.718v-1.15c0.002-0.34 0.279-0.614 0.619-0.614 0.342 0 0.619 0.277 0.619 0.619 0 0.002 0 0.003-0 0.005v-0 1.142h0.736l0.017-9.546zM11.272 16.413h-1.238v-1.238h1.241zM11.272 14.413h-1.238v-1.238h1.241zM11.281 12.414h-1.238v-1.238h1.232zM13.228 16.411h-1.238v-1.238h1.238zM13.228 14.412h-1.238v-1.238h1.238zM13.236 12.413h-1.238v-1.238h1.235zM15.184 16.419h-1.238v-1.235h1.238zM15.184 14.42h-1.238v-1.238h1.238zM15.192 12.42h-1.238v-1.238h1.239z"
      />
      <path
        fill="#fff"
        d="M5.456 10.433l3.323-2.778v11.942h-3.323zM8.087 13.589h-0.883v0.883h0.883zM8.087 12.005h-0.883v0.883h0.883zM8.087 10.422h-0.883v0.883h0.883z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
